import { theme } from "../../../../../../theme";
import getREMFromPX from "../../../../../../utils/getREMFromPX";

export const dividerStyles = {
  height: getREMFromPX(theme.spacing * 5),
  alignSelf: "center",
};
